export enum Scope {
    SBOM_PROJECT = "SBOM_PROJECT",
    SBOM_PROJECT_GROUP = "SBOM_PROJECT_GROUP"
}

export function formatScope(scope: Scope) {
    switch (scope) {
        case Scope.SBOM_PROJECT:
            return "Project";
        case Scope.SBOM_PROJECT_GROUP:
            return "Project group";
    }
}

export function scopeRequiresObjectId(scope: Scope) {
    switch (scope) {
        case Scope.SBOM_PROJECT:
            return true;
        case Scope.SBOM_PROJECT_GROUP:
            return true;
    }
}
